export const LOCATION_CHANGE =
  '@sde-widgets-core/common/redux/router/LOCATION_CHANGE';
export const PUSH = '@sde-widgets-core/common/redux/router/PUSH';
export const REPLACE = '@sde-widgets-core/common/redux/router/REPLACE';
export const GO = '@sde-widgets-core/common/redux/router/GO';
export const GO_BACK = '@sde-widgets-core/common/redux/router/GO_BACK';
export const GO_FORWARD = '@sde-widgets-core/common/redux/router/GO_FORWARD';

export const onLocationChanged = (location, action) => {
  return {
    type: LOCATION_CHANGE,
    payload: {
      location,
      action,
    },
  };
};

export const updateLocation = (type, method) => {
  return (...args) => ({
    type,
    payload: {
      method,
      args,
    },
  });
};

export const push = updateLocation(PUSH, 'push');
export const replace = updateLocation(REPLACE, 'replace');
export const go = updateLocation(GO, 'go');
export const goBack = updateLocation(GO_BACK, 'goBack');
export const goForward = updateLocation(GO_FORWARD, 'goForward');

export const routerActions = {
  onLocationChanged,
  push,
  replace,
  go,
  goBack,
  goForward,
};
